export interface SpinnerArgs {
	root: HTMLElement,
	spinnerSelector: string,
	spinningClass: string,
	disableSelector?: string;
}

export class SpinnerHelper {
	public static async spinAndDeactivateWhile<TResult>(promise: Promise<TResult>, args?: SpinnerArgs): Promise<TResult> {

		try {
			const result = await promise;
			return result;
		} catch (exception) {
			throw exception;
		} 
	}

	public static startSpinning () {
		var args : SpinnerArgs= {
			root: document.body,
			spinnerSelector: "._spinnerContainer",
			spinningClass: "_spinning"
		}

		const spinners = args.root.querySelectorAll(args.spinnerSelector);

		for (const spinner of spinners) {
			spinner.classList.add(args.spinningClass);
		}

		const disableElements = args.disableSelector ? args.root.querySelectorAll(args.disableSelector) : []

		for (const disableElement of disableElements) {
			(disableElement as any).disabled = true;
		}

	}

	public static stopSpinning() {
		var args : SpinnerArgs= {
			root: document.body,
			spinnerSelector: "._spinnerContainer",
			spinningClass: "_spinning"
		}
		const spinners = args.root.querySelectorAll(args.spinnerSelector);
		const disableElements = args.disableSelector ? args.root.querySelectorAll(args.disableSelector) : []

		for (const spinner of spinners) {
			spinner.classList.remove(args.spinningClass);
		}

		for (const disableElement of disableElements) {
			(disableElement as any).disabled = false;
		}
	}
}